import { ValidateUserPaymentDetailsInputDto } from '@starsoft/common/dto';
import { AxiosInstance, AxiosResponse } from 'axios';
import { UserPaymentDetailsValidationResult } from '../../../../models/user-payment-details/validation/result';

export async function fetchValidateUserPaymentDetails(
  data: ValidateUserPaymentDetailsInputDto,
  axiosInstance: AxiosInstance,
): Promise<UserPaymentDetailsValidationResult> {
  const response: AxiosResponse<UserPaymentDetailsValidationResult> =
    await axiosInstance.post<UserPaymentDetailsValidationResult>(
      '/user-payment-details/validate',
      data,
    );
  return response.data;
}
